// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchHeader-module__wrapper"};